import { useQuery } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const getFullVesselListQuery = () => {
    return axios.get(apiurl?.getFullVesselList);
};

const getFullVesselList = () => {
    return useQuery(['getFullVesselList'], () => getFullVesselListQuery());
};

export default getFullVesselList;
